import React from 'react'
import { StyledButton } from './style'
import { FormattedMessage } from 'react-intl'
import DownloadCalendarButton from '@components/DownloadCalendarButton'
import LastRefresh from '@components/LastRefresh'

const HeaderButtons: React.FC<{
  hasValidProgram: boolean
  onViewMonth: () => {}
  selectedMonth: string
  refetch: () => {}
}> = ({ hasValidProgram, onViewMonth, selectedMonth, refetch }) => {
  return hasValidProgram ? (
    <>
      <div className="btns">
        <StyledButton onClick={onViewMonth} ghost>
          <FormattedMessage id="View month" />
          <span>:&nbsp;</span>
          <FormattedMessage id={selectedMonth} />
        </StyledButton>
        <DownloadCalendarButton />
      </div>
      <LastRefresh loading={false} handleRefresh={refetch} alignRight />
    </>
  ) : (
    <></>
  )
}

export default HeaderButtons
